import React from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { formValues } from 'redux-form'
import { Select } from '../../../../components/FormBuilder'
import { IStore } from '../../../../reducers'
import { getPaymentDictionaryWithoutDeleted } from '../../../../reducers/paymentDictionary/selectors/getPaymentDictionary'

const SelectWithDictionary = ({
  dictionary,
  t,
  formValue,
  zIndex = 'unset',
  ...rest
}: any) => {
  let values = [
    t('payment_type_credit_card'),
    t('payment_type_bank_transfer'),
    t('payment_type_cash'),
  ]

  values = values.filter(v => v !== formValue)

  return (
    <Select.ReduxField
      zIndex={2000}
      wrapperStyle={{ zIndex: zIndex }}
      {...rest}
    >
      {formValue && formValue !== undefined ? (
        <Select.Option key={formValue} value={formValue}>
          {formValue}
        </Select.Option>
      ) : null}
      {values.map(v => (
        <Select.Option key={v} value={v}>
          {v}
        </Select.Option>
      ))}
      {dictionary &&
        dictionary.length !== 0 &&
        dictionary
          .filter(dict => formValue !== dict.name)
          .map(dict => (
            <Select.Option key={dict.name} value={dict.name}>
              {dict.name}
            </Select.Option>
          ))}
    </Select.ReduxField>
  )
}

export default connect((state: IStore) => ({
  dictionary: getPaymentDictionaryWithoutDeleted(state),
}))(
  withTranslation()(formValues(props => ({ formValue: props.name }))(
    SelectWithDictionary,
  ) as any),
) as any
